/* ===================== */
/* script para "filtrar" imagens referentes a variante de cor selecionada */
/* ===================== */
(() => {
  const COLOR_NAMES = ['cor', 'color'];

  const norm = (s) =>
    (s || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, ''); // tira acentos

  function getSelectedColorValue() {
    const root = document.querySelector('variant-selects');
    if (!root) return '';

    // procura o select/radio cuja label seja "Cor/Color"
    const dropdowns = [...root.querySelectorAll('.product-form__input--dropdown')];
    for (const wrap of dropdowns) {
      const label = wrap.querySelector('label.form__label');
      const select = wrap.querySelector('select');
      if (!label || !select) continue;

      if (COLOR_NAMES.includes(norm(label.textContent))) {
        return norm(select.value);
      }
    }

    // fallback radios (pill/swatch)
    const fieldsets = [...root.querySelectorAll('fieldset.product-form__input')];
    for (const fs of fieldsets) {
      const legend = fs.querySelector('legend.form__label');
      if (!legend) continue;

      if (COLOR_NAMES.includes(norm(legend.textContent))) {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return norm(checked?.value || '');
      }
    }

    return '';
  }

  function applyFilter() {
    const container = document.querySelector('.objetos-scroll');
    if (!container) return;

    const items = [...container.querySelectorAll('.img-container[data-media-id]')];
    if (!items.length) return;

    const selectedColor = getSelectedColorValue();

    // se não achou cor (produto sem cor), mostra tudo
    if (!selectedColor) {
      items.forEach((el) => el.classList.remove('hidden'));
      return;
    }

    let shown = 0;

    items.forEach((el) => {
      const alt = norm(el.getAttribute('data-alt') || el.querySelector('img')?.alt || '');
      const isGeneric = !alt; // sem ALT = genérica
      const matches = alt === selectedColor;

      const shouldShow = isGeneric || matches;
      el.classList.toggle('hidden', !shouldShow);
      if (shouldShow) shown++;
    });

    // fallback: se não tiver nenhuma específica, mostra tudo
    const hasSpecific = items.some((el) => norm(el.getAttribute('data-alt') || '') === selectedColor);
    if (!hasSpecific) items.forEach((el) => el.classList.remove('hidden'));
  }

  function bind() {
    document.addEventListener('DOMContentLoaded', applyFilter);
    document.addEventListener('product-info:loaded', applyFilter);

    document.addEventListener('change', (e) => {
      if (e.target.closest('variant-selects, variant-radios, .product-form__input')) applyFilter();
    });
  }

  bind();
})();